module.exports = __webpack_public_path__ + "r-v3/img/mobile_premium_feature_006.5d9d2c99.jpg";